import React from "react";
import { Box, Typography } from "@mui/material";
import TagCard from "components/Cards";
import { NavLink } from "react-router-dom";

// Componente base reutilizável para exibir título, valor/link e um ícone
const InviteCardBase = ({
  title,
  value,
  icon,
  linkHoverColor = "#662D91",
  hoverText,
  onHoverClick,
  hoverLinkTo,
  altType,
}) => {
  // Define qual componente será usado como wrapper (NavLink se houver link, caso contrário Box)
  const CardWrapper = hoverLinkTo ? NavLink : Box;

  return (
    <CardWrapper to={hoverLinkTo} style={{ textDecoration: "none" }}>
      <TagCard
        component={hoverLinkTo ? NavLink : Box}
        to={hoverLinkTo}
        onClick={onHoverClick}
        sx={{
          width: "100%",
          height: "110px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          flexWrap: "nowrap",
          alignItems: "center",
          padding: "16px",
          boxSizing: "border-box",
          cursor: "pointer",

          // Estilo ao passar o mouse (hover)
          "&:hover": {
            border: "2px solid #662D91",
            background: "#E1DAE6",
          },

          // Oculta o texto padrão e mostra o link no hover
          "&:hover .default-link": {
            display: "none",
          },
          "&:hover .hover-link": {
            display: "inline",
          },

          // Altera a cor do link no hover
          "&:hover a": {
            color: linkHoverColor,
          },
        }}
      >
        {/* Container do conteúdo */}
        <Box
          sx={{
            display: "flex",
            justifyContent: { xs: "flex-end", sm: "space-between" },
            alignItems: { xs: "flex-end", sm: "center" },
            width: "100%",
            flexWrap: "nowrap",
          }}
        >
          {/* Lado esquerdo: título e texto */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "flex-start",
              marginLeft: "10px",
            }}
          >
            {/* Título do card */}
            <Typography
              sx={{
                color: "#4d4d4d",
                fontWeight: 500,
                fontSize: { xs: "0.8rem", sm: "1rem", md: "1.1rem" },
              }}
            >
              {title}
            </Typography>

            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
              }}
            >
              {/* Valor padrão (visível até o hover) */}
              <Typography
                className={altType ? "default-link" : ""}
                sx={{
                  color: "#9a9a9a",
                  fontSize: { xs: "0.7rem", sm: "0.9rem" },
                  marginTop: "15px",
                }}
              >
                {value}
              </Typography>

              {/* Texto exibido no hover */}
              <Typography
                className="hover-link"
                component={NavLink}
                to={hoverLinkTo}
                target="_blank"
                href={hoverLinkTo}
                sx={{
                  textDecoration: "underline",
                  color: "#662D91",
                  cursor: "pointer",
                  fontSize: { xs: "0.7rem", sm: "0.85rem", md: "0.9rem" },
                  marginTop: "15px",
                  display: "none",
                  marginLeft: altType ? 0 : "25px",
                }}
              >
                {hoverText}
              </Typography>
            </Box>
          </Box>

          {/* Lado direito: ícone */}
          <Box
            sx={{
              display: { xs: "none", sm: "block" }, // Ícone só visível em telas maiores
              color: "#662D91",
              mr: { md: 1 },
              mt: { sm: "20px", md: "20px" },
            }}
          >
            {icon}
          </Box>
        </Box>
      </TagCard>
    </CardWrapper>
  );
};

export default InviteCardBase;
